export default __webpack_public_path__ + "static/media/world-a-title.448d4124.png";